const situationRouter = [
  {
      path: "list-situation",
      name: "situation",
      component: () => import("@/views/admin/situation"),
      default: true,
      meta: {
          model: "situation",
          // requiresAuth: true,
      },
  },
  {
      path: "list-situation/add",
      name: "addSituation",
      component: () => import("@/views/admin/situation/function"),
      default: true,
      meta: {
          model: "situation",
          // requiresAuth: true,
      },
  },
  {
      path: "list-situation/edit/:id",
      name: "editSituation",
      component: () => import("@/views/admin/situation/function"),
      default: true,
      meta: {
          model: "situation",
          // requiresAuth: true,
      },
  }
]
export default situationRouter;